import { createReducer } from 'typesafe-actions';
import { AugmentedItineraryData, ErrorData, UserData } from '../../services/types';
import { clearUserData, getShipItinerary, loginUser } from './user.actions';
import ports from '../../assets/data/dataset.json';
import { toggleLogin } from '../uiControl/uiControl.actions';


export interface UserStateInterface {
  userData?: UserData;
  token?: string;
  errorData?: ErrorData;
  itinerary?: AugmentedItineraryData[];
  numberOfPortsTraveled?: number;
}

export const UserState: UserStateInterface = {};

export default createReducer<UserStateInterface>(UserState)
  .handleAction(
    loginUser.success,
    (state, action) => {
      return {
        ...state,
        userData: action.payload.details,
        token: action.payload.token
      };
    }
  )
  .handleAction(
    loginUser.failure,
    (state, action) => {
      return {
        ...state,
        errorData: action.payload
      };
    }
  )
  .handleAction(
    toggleLogin,
    (state, action) => {
      return {
        ...state,
        errorData: undefined
      };
    }
  )
  .handleAction(
    clearUserData,
    (state, action) => {
      localStorage.removeItem('user');
      return {};
    }
  )
  .handleAction(
    getShipItinerary.success,
    (state, action) => {
      const augmentedLocations = action.payload.reduce((accumulator: AugmentedItineraryData[], location) => {
        const additionInfo = ports.find((port) => port.id === location.portCode);
        if (additionInfo) {
          accumulator.push(({ ...location, ...additionInfo }));
        }
        return accumulator;
      }, []);

      //Remove dups
      const locations: any = {};
      augmentedLocations.forEach((location) => {
        locations[location.id] = location;
      });

      return {
        ...state,
        itinerary: augmentedLocations,
        numberOfPortsTraveled: Object.values(locations).length,
      };
    }
  );

